import { Injectable } from "@angular/core";
import { Response, RequestOptions, Headers } from "@angular/http";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";

import { HttpService } from "./http.service";
import { Locale } from "@atenea-cms";

@Injectable()
export abstract class CrudService {
  rootUrl: string = "";
  abstract getRootUrl(): string;

  constructor(public http: HttpService) {
    this.rootUrl = this.getRootUrl();
  }

  getAll(): Observable<any> {
    return this.http.get(`/${this.rootUrl}`).map(this.http.getJsonData);
  }

  getById(id: string): Observable<any> {
    return this.http.get(`/${this.rootUrl}/${id}`).map(this.http.getJsonData);
  }

  remove(id: string): Observable<Response> {
    return this.http.delete(`/${this.rootUrl}/${id}`);
  }

  duplicate(id: string): Observable<any> {
    return this.http
      .post(`/${this.rootUrl}/duplicate/${id}`, {})
      .map(this.http.getJsonData);
  }

  save(item: any): Observable<any> {
    if (item._id) {
      console.log(item);
      return this.http
        .put(`/${this.rootUrl}/${item._id}`, item)
        .map(this.http.getJsonData);
    } else {
      return this.http
        .post(`/${this.rootUrl}`, item)
        .map(this.http.getJsonData);
    }
  }

  saveMultiple(items: Array<any>): Observable<any> {
    return this.http.put(`/${this.rootUrl}/multiple`, items);
  }

  getDataForLocale(id: string, locale: Locale): Observable<any> {
    const headers = new Headers();
    headers.append("i18n-locale", locale.code);

    const options = new RequestOptions({ headers: headers });
    return this.http
      .get(`/${this.rootUrl}/${id}`, options)
      .map(this.http.getJsonData);
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/core/services/crud.service.ts